import { Language } from '@data/sdk/match';

export const isTranslationsEmpty = (translations: Record<Language, string>) => {
  return Object.values(translations).every((value) => value === '');
};
